import { useDownloadStore } from '../../store/downloadStore';
import type { DownloadScope, DownloadTarget } from './types';

export * from './types';
export { ZipDownload } from './zipDownloader';

/**
 * Feature flag for the client-side archiver.
 *
 * While this is off, every download falls back to the server-built ZIP path.
 * Flipping it off is the rollback for the whole project, which is why the old
 * endpoints stay in place until the new path has been stable in production.
 */
export const CLIENT_ZIP_ENABLED =
  (import.meta.env['VITE_CLIENT_ZIP'] ?? (import.meta.env.DEV ? 'true' : 'false')) === 'true';

/**
 * Start a client-side ZIP download. Resolves once the download finishes — the
 * DownloadPanel owns all progress reporting, so callers don't need a toast.
 *
 * Must be called from a user gesture: the file/directory picker won't open
 * otherwise.
 */
export function startClientZip(opts: {
  target: DownloadTarget;
  albumName: string;
  scope: DownloadScope;
  photoIds?: string[];
}): Promise<void> {
  return useDownloadStore.getState().start(opts);
}
